import { UploadOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Form,
  Image,
  Input,
  message,
  Row,
  Select,
  Space,
  Spin,
  Upload,
} from 'antd';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import { find, isEmpty } from 'lodash';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import BrandApi from '../../functions/api/vehicle/BrandApi';
import FuelApi from '../../functions/api/vehicle/FuelApi';
import ImageApi from '../../functions/api/vehicle/ImageApi';
import MotorbikeApi from '../../functions/api/vehicle/MotorbikeApi';
import TransmissionApi from '../../functions/api/vehicle/TransmissionApi';
import TypeApi, { VEHICLE_TYPES } from '../../functions/api/vehicle/TypeApi';
import VehicleApi from '../../functions/api/vehicle/VehicleApi';
import { filterOption, normalizeOptions } from '../booking/form/CustomSelect';
import SelectBrands from '../vehiclePartner/select/Brand';

const formItemLayout = {
  wrapperCol: { span: 24 },
  labelCol: { span: 24 },
};

const normFile = (e) => {
  if (Array.isArray(e)) {
    return e;
  }

  return e && e.fileList;
};

class FormAddMotorbike extends Component {
  constructor(props) {
    super(props);
    this.state = {
      types: [],
      brands: [],
      transmissions: [],
      fuels: [],
      vhc_display: true,
      isEdit: false,
      vehicles: null,
    };
  }
  formRef = React.createRef();

  componentDidMount = async () => {
    let brands, fuels, transmissions, models, types;
    brands = await BrandApi.getBrandByType(VEHICLE_TYPES.MOTOBIKE);
    brands = brands ? brands : [];

    types = await TypeApi.getAll();
    types = types ? types : [];

    transmissions = await TransmissionApi.getAllTransmisssion(
      VEHICLE_TYPES.MOTOBIKE
    );
    transmissions = transmissions ? transmissions : [];

    fuels = await FuelApi.getAllFuel();
    fuels = fuels ? fuels : [];

    this.setState({
      brands,
      models,
      transmissions,
      fuels,
      types,
    });

    if (
      this.props.match.params &&
      this.props.match.path === '/vehicle-depot/edit-moto-depot/:vhc_id'
    ) {
      let vhc_id = this.props.match.params.vhc_id;
      if (vhc_id) {
        let detail = await VehicleApi.getDetailVehicle(vhc_id);

        detail.version = detail.vhc_name;

        if (detail.vhc_type_id === VEHICLE_TYPES.MOTOBIKE) {
          this.setState({ isEdit: true });
        }

        this.setState({
          vehicle: detail,
        });
      }
    }
  };

  handleImage = async (e) => {
    const path = await ImageApi.uploadHandler(e);

    return path;
  };

  onSelectedChangeHide = (checked) => {
    this.formRef.current.setFieldsValue({
      vhc_hide: checked ? 1 : 0,
    });
  };

  submitForm = async (values) => {
    const { brands, transmissions, fuels, isEdit, vehicle, types } = this.state;

    let payload = {
      ...values,
    };
    let img;
    if (!isEdit) {
      if (payload.img === undefined) {
        alert('Vui lòng upload ảnh xe');
        return;
      }
      img = await this.handleImage(payload.img[0]);
    } else {
      if (isEmpty(payload.img)) {
        img = vehicle.vhc_imgs[0].vhc_img_link;
      } else {
        img = await this.handleImage(payload.img[0]);
      }
    }

    payload.vhc_imgs = img;
    delete payload.img;

    const vhc_bran_name = find(brands, {
      vhc_bran_id: payload.vhc_bran_id,
    })?.vhc_bran_name;
    payload.vhc_bran_name = vhc_bran_name;

    const vhc_tms_name = find(transmissions, {
      vhc_tms_id: payload.vhc_tms_id,
    })?.vhc_tms_name;
    payload.vhc_tms_name = vhc_tms_name;

    const vhc_fuel_name = find(fuels, {
      vhc_fuel_id: payload.vhc_fuel_id,
    })?.vhc_fuel_name;
    payload.vhc_fuel_name = vhc_fuel_name;

    payload.vhc_type_id = VEHICLE_TYPES.MOTOBIKE;

    const vhc_type_name = find(types, {
      vhc_type_id: VEHICLE_TYPES.MOTOBIKE,
    })?.vhc_type_name;
    payload.vhc_type_name = vhc_type_name;

    payload.vhc_crta = isEdit ? vehicle.vhc_crta : new Date();

    payload.vhc_id = isEdit ? vehicle.vhc_id : undefined;

    payload.vhc_name = payload.version;

    await this.handleCreate(payload);
  };

  handleCreate = async (payload) => {
    const { isEdit } = this.state;

    let res;
    if (isEdit) {
      await MotorbikeApi.editMotorbike(payload).then(
        (response) => (res = response)
      );
    } else
      await MotorbikeApi.createMotorbike(payload).then(
        (response) => (res = response)
      );
    if (res.code === 'error') {
      message.error('Lỗi, hãy kiểm tra lại');
    } else {
      if (isEdit) {
        message.success('Cập nhập xe thành công');
      } else {
        message.success('Thêm xe xe thành công');
      }
    }
  };

  render() {
    const { fuels, transmissions, isEdit, vehicle } = this.state;

    if (!vehicle && isEdit) {
      return <Spin />;
    }
    return (
      <>
        {!isEdit ? (
          <>
            <Button>
              <Link to="/vehicle-depot/add-car" className="tab-car ">
                Ô tô
              </Link>
            </Button>
            <Button type="primary">
              <a className="tab-moto active">Xe máy</a>
            </Button>
          </>
        ) : (
          <h1>Sửa xe máy</h1>
        )}

        <Form
          {...formItemLayout}
          initialValues={vehicle}
          onFinish={this.submitForm}
          ref={this.formRef}
        >
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name={['version']}
                label="Nhập Version"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['vhc_bran_id']}
                label="Hãng xe"
                rules={[{ required: true }]}
              >
                <SelectBrands
                  onBrandChange={this.onChangeSelectBrand}
                  vehicleType={VEHICLE_TYPES.MOTOBIKE}
                  selected={vehicle?.vhc_bran_id}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['vhc_tms_id']}
                label="Chọn loại hộp số"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={filterOption}
                  options={normalizeOptions(
                    'vhc_tms_name',
                    'vhc_tms_id',
                    transmissions
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['vhc_fuel_id']}
                label="Chọn loại nhiên liệu"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={filterOption}
                  options={normalizeOptions(
                    'vhc_fuel_name',
                    'vhc_fuel_id',
                    fuels
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['vhc_egin_num']}
                label="Nhập dung tích xi lanh"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['vhc_hide']}
                valuePropName="checked"
                label="Ẩn xe"
              >
                <Checkbox>Ẩn</Checkbox>
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="img"
                label="Upload"
                valuePropName="fileList"
                getValueFromEvent={normFile}
              >
                <Upload listType="picture">
                  <Button icon={<UploadOutlined />}>
                    {isEdit ? 'Thay ảnh xe' : 'Upload ảnh xe'}
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
            {isEdit && (
              <Image width={200} src={vehicle?.vhc_imgs[0].vhc_img_link} />
            )}
          </Row>
          <Space>
            <Button htmlType="submit" type="primary">
              Lưu
            </Button>
            <Link
              to="/vehicle-depot"
              component={(props) => (
                <Button type="default" {...props}>
                  Quay lại
                </Button>
              )}
            />
          </Space>
        </Form>
      </>
    );
  }
}

export default FormAddMotorbike;
